import * as React from "react";
import { connect, type ConnectedProps } from "react-redux";
import { LAYOUT_QUICK_MENU_TOGGLE } from "../../Actions/General/LayoutActions";
import { type RootState } from "../../Reducers/ShopfrontReducers";
import { fireEventType } from "../../Utilities/Generic/ActionsHelper";
import Logo from "./QuickMenuAndLogo/Logo";
import QuickMenu from "./QuickMenuAndLogo/QuickMenu";

const connector = connect((state: RootState) => ({
    open: state.layout.quickMenu.open,
}));

type PropsFromRedux = ConnectedProps<typeof connector>;

class QuickMenuAndLogo extends React.Component<PropsFromRedux> {
    public handleClick = (e: React.MouseEvent<HTMLAnchorElement>): void => {
        e.preventDefault();

        this.props.dispatch(fireEventType(LAYOUT_QUICK_MENU_TOGGLE));
    };

    public render(): React.ReactNode {
        return (
            <div
                className="header-item"
                data-testid="sh-quick-menu"
            >
                <Logo onClick={this.handleClick} />
                <QuickMenu visible={this.props.open} />
            </div>
        );
    }
}

export default connector(QuickMenuAndLogo);
